import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Header.scss';
import Heading from '../../Heading';
import Text from '../../Text';

var isString = function isString(a) {
  return typeof a === 'string';
};

var Header = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Header, _React$PureComponent);

  var _super = _createSuper(Header);

  function Header() {
    _classCallCheck(this, Header);

    return _super.apply(this, arguments);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          suffix = _this$props.suffix;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.titleWrapper
      }, isString(title) ? /*#__PURE__*/React.createElement(Heading, {
        dataHook: "title",
        appearance: "H3",
        children: title
      }) : /*#__PURE__*/React.createElement("span", {
        "data-hook": "title"
      }, title), subtitle && isString(subtitle) ? /*#__PURE__*/React.createElement(Text, {
        dataHook: "subtitle",
        children: subtitle,
        secondary: true
      }) : /*#__PURE__*/React.createElement("span", {
        "data-hook": "subtitle"
      }, subtitle)), suffix && /*#__PURE__*/React.createElement("div", {
        "data-hook": "suffix",
        className: styles.suffix,
        children: suffix
      })));
    }
  }]);

  return Header;
}(React.PureComponent);

_defineProperty(Header, "displayName", 'Card.Header');

_defineProperty(Header, "propTypes", {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** required card title */
  title: PropTypes.node.isRequired,

  /** any string to be rendered below title */
  subtitle: PropTypes.node,
  suffix: PropTypes.node
});

_defineProperty(Header, "defaultProps", {
  subtitle: null,
  suffix: null
});

export default Header;